// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#main-content {
  display: block;
  /* El header es fijo y su altura real (toolbar + safe-area-inset-top en móvil)
     la calcula AppComponent en --app-offset-top.
     El outlet está posicionado de forma absoluta con los insets a 0. Usamos
     \`top\` (y no \`margin-top\`) para desplazarlo: un margen superior lo sacaba
     fuera del viewport por abajo, recortando el final del contenido (que
     quedaba por debajo del menú inferior) y tapando la parte superior. */
  position: absolute;
  left: 0;
  right: 0;
  top: var(--app-offset-top, 56px);
  bottom: 0;
}

#main-content ion-content {
  height: 100%;
}

.blinking {
  animation: blink 1s infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
/* Header fijo por encima del contenido */
ion-header.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* Aspecto translúcido del header principal */
ion-header.app-header[translucent] ion-toolbar {
  --background: rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.7);
  backdrop-filter: saturate(180%) blur(16px);
  -webkit-backdrop-filter: saturate(180%) blur(16px);
}

/* Aspecto translúcido del menú lateral */
ion-menu.translucent-menu {
  --background: #000;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

/* Si el menú tiene header, aplicamos también translucidez al toolbar interno */
ion-menu.translucent-menu ion-header[translucent] ion-toolbar {
  --background: #000;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

/* Centrar el título (logo) exactamente en el medio del toolbar */
ion-header.app-header ion-toolbar {
  position: relative;
}

/* Ajuste: centrar también verticalmente el logo en el toolbar */
ion-header.app-header ion-toolbar ion-title.logo-title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  pointer-events: none; /* evita bloquear clics en botones laterales */
}

ion-title.logo-title {
  display: flex;
  justify-content: center;
  align-items: center;
}

ion-title.logo-title img {
  max-height: 28px;
  height: 28px;
  width: auto;
}

.menu-item {
  --padding-start: 16px; /* padding izquierdo para separar el texto del borde */
}

ion-menu .menu-user {
  padding: 12px;
}

ion-menu .menu-user ion-button {
  --background: #ffd54f; /* amarillo suave */
  --color: #000;
  border-radius: 8px;
}

ion-menu .menu-user ion-item {
  --background: transparent;
  --padding-start: 8px;
}

ion-menu .menu-user ion-label {
  font-weight: 600;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

ion-menu .menu-profile-item {
  --background: transparent;
  --color: #000;
}

ion-menu .menu-user ion-avatar {
  width: 40px;
  height: 40px;
}

ion-menu .menu-footer-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0 24px;
}

ion-menu .menu-footer-logo img {
  max-width: 160px;
  height: auto;
  opacity: 0.9;
}

/* Parpadeo rojo del icono de notificaciones en el header cuando hay avisos */
.notif-blink {
  --color: #e53935; /* rojo intenso */
}

.notif-blink ion-icon {
  color: #e53935 !important;
  animation: notif-red-blink 1.2s steps(1, start) infinite;
}

@keyframes notif-red-blink {
  0%, 50%, 100% {
    opacity: 1;
  }
  25%, 75% {
    opacity: 0;
  }
}
ion-menu .menu-user .menu-user-name {
  color: var(--ion-color-primary);
}

/* Avatar redondo y no estirado en botón del header (ajuste adicional) */
ion-header.app-header ion-buttons[slot=end] ion-button ion-avatar[slot=icon-only] {
  width: 36px !important;
  height: 36px !important;
  border-radius: 50%;
  overflow: hidden;
  flex: 0 0 auto;
  display: inline-block;
}

ion-header.app-header ion-buttons[slot=end] ion-button ion-avatar[slot=icon-only] img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  border-radius: 50%;
}

/* Avatar del menú lateral perfectamente circular */
ion-menu .menu-user ion-avatar {
  border-radius: 50%;
  overflow: hidden;
}

ion-menu .menu-user ion-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,cAAA;EACA;;;;;yEAAA;EAMA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,gCAAA;EACA,SAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,4BAAA;AAEF;;AACA;EACE;IAAK,UAAA;EAGL;EAFA;IAAM,YAAA;EAKN;EAJA;IAAO,UAAA;EAOP;AACF;AALA,yCAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;AAOF;;AAJA,6CAAA;AACA;EACE,uEAAA;EACA,0CAAA;EACA,kDAAA;AAOF;;AAJA,yCAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,6BAAA;AAOF;;AAJA,+EAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,6BAAA;AAOF;;AAJA,iEAAA;AACA;EACE,kBAAA;AAOF;;AALA,gEAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA,EAAA,8CAAA;AAQF;;AANA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AASF;;AAPA;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AAUF;;AAPA;EACE,qBAAA,EAAA,sDAAA;AAUF;;AAPA;EACE,aAAA;AAUF;;AARA;EACE,qBAAA,EAAA,mBAAA;EACA,aAAA;EACA,kBAAA;AAWF;;AATA;EACE,yBAAA;EACA,oBAAA;AAYF;;AAVA;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAaF;;AAXA;EACE,yBAAA;EACA,aAAA;AAcF;;AAZA;EACE,WAAA;EACA,YAAA;AAeF;;AAbA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AAgBF;;AAdA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;AAiBF;;AAdA,6EAAA;AACA;EACE,gBAAA,EAAA,iBAAA;AAiBF;;AAfA;EACE,yBAAA;EACA,wDAAA;AAkBF;;AAhBA;EACE;IAAgB,UAAA;EAoBhB;EAnBA;IAAW,UAAA;EAsBX;AACF;AArBA;EACE,+BAAA;AAuBF;;AApBA,wEAAA;AACA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAuBF;;AArBA;EACE,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAwBF;;AArBA,mDAAA;AACA;EACE,kBAAA;EACA,gBAAA;AAwBF;;AAtBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAyBF","sourcesContent":["#main-content {\n  display: block;\n  /* El header es fijo y su altura real (toolbar + safe-area-inset-top en móvil)\n     la calcula AppComponent en --app-offset-top.\n     El outlet está posicionado de forma absoluta con los insets a 0. Usamos\n     `top` (y no `margin-top`) para desplazarlo: un margen superior lo sacaba\n     fuera del viewport por abajo, recortando el final del contenido (que\n     quedaba por debajo del menú inferior) y tapando la parte superior. */\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: var(--app-offset-top, 56px);\n  bottom: 0;\n}\n\n#main-content ion-content {\n  height: 100%;\n}\n\n.blinking {\n  animation: blink 1s infinite;\n}\n\n@keyframes blink {\n  0% { opacity: 1; }\n  50% { opacity: 0.4; }\n  100% { opacity: 1; }\n}\n\n/* Header fijo por encima del contenido */\nion-header.app-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n}\n\n/* Aspecto translúcido del header principal */\nion-header.app-header[translucent] ion-toolbar {\n  --background: rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.7);\n  backdrop-filter: saturate(180%) blur(16px);\n  -webkit-backdrop-filter: saturate(180%) blur(16px);\n}\n\n/* Aspecto translúcido del menú lateral */\nion-menu.translucent-menu {\n  --background: #000;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n\n/* Si el menú tiene header, aplicamos también translucidez al toolbar interno */\nion-menu.translucent-menu ion-header[translucent] ion-toolbar {\n  --background: #000;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n\n/* Centrar el título (logo) exactamente en el medio del toolbar */\nion-header.app-header ion-toolbar {\n  position: relative;\n}\n/* Ajuste: centrar también verticalmente el logo en el toolbar */\nion-header.app-header ion-toolbar ion-title.logo-title {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  pointer-events: none; /* evita bloquear clics en botones laterales */\n}\nion-title.logo-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\nion-title.logo-title img {\n  max-height: 28px;\n  height: 28px;\n  width: auto;\n}\n\n.menu-item {\n  --padding-start: 16px; /* padding izquierdo para separar el texto del borde */\n}\n\nion-menu .menu-user {\n  padding: 12px;\n}\nion-menu .menu-user ion-button {\n  --background: #ffd54f; /* amarillo suave */\n  --color: #000;\n  border-radius: 8px;\n}\nion-menu .menu-user ion-item {\n  --background: transparent;\n  --padding-start: 8px;\n}\nion-menu .menu-user ion-label {\n  font-weight: 600;\n  color: #000;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\nion-menu .menu-profile-item {\n  --background: transparent;\n  --color: #000;\n}\nion-menu .menu-user ion-avatar {\n  width: 40px;\n  height: 40px;\n}\nion-menu .menu-footer-logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 0 24px;\n}\nion-menu .menu-footer-logo img {\n  max-width: 160px;\n  height: auto;\n  opacity: 0.9;\n}\n\n/* Parpadeo rojo del icono de notificaciones en el header cuando hay avisos */\n.notif-blink {\n  --color: #e53935; /* rojo intenso */\n}\n.notif-blink ion-icon {\n  color: #e53935 !important;\n  animation: notif-red-blink 1.2s steps(1, start) infinite;\n}\n@keyframes notif-red-blink {\n  0%, 50%, 100% { opacity: 1; }\n  25%, 75% { opacity: 0; }\n}\nion-menu .menu-user .menu-user-name {\n  color: var(--ion-color-primary);\n}\n\n/* Avatar redondo y no estirado en botón del header (ajuste adicional) */\nion-header.app-header ion-buttons[slot=\"end\"] ion-button ion-avatar[slot=\"icon-only\"] {\n  width: 36px !important;\n  height: 36px !important;\n  border-radius: 50%;\n  overflow: hidden;\n  flex: 0 0 auto;\n  display: inline-block;\n}\nion-header.app-header ion-buttons[slot=\"end\"] ion-button ion-avatar[slot=\"icon-only\"] img {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n/* Avatar del menú lateral perfectamente circular */\nion-menu .menu-user ion-avatar {\n  border-radius: 50%;\n  overflow: hidden;\n}\nion-menu .menu-user ion-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
